import { __assign, __rest } from "tslib";
import React, { forwardRef } from 'react';
import { RcTooltip } from '../Tooltip';
/**
 * Make a component can be use with `RcTooltip` and Tooltip Props
 */
function withTooltip(Component) {
    return forwardRef(function (props, ref) {
        var title = props.title, useRcTooltip = props.useRcTooltip, TooltipProps = props.TooltipProps, rest = __rest(props, ["title", "useRcTooltip", "TooltipProps"]);
        if (title && useRcTooltip) {
            return (React.createElement(RcTooltip, __assign({ title: title }, TooltipProps),
                React.createElement(Component, __assign({}, rest, { ref: ref }))));
        }
        return React.createElement(Component, __assign({ title: title }, rest, { ref: ref }));
    });
}
export { withTooltip };
